import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
/**
 * Input component with label, error state, and help text.
 * Accessible: label linked via htmlFor, error via aria-describedby.
 */
export const Input = forwardRef(({ label, error, helpText, id, className = '', ...props }, ref) => {
    const inputId = id || `input-${label.toLowerCase().replace(/\s/g, '-')}`;
    const errorId = `${inputId}-error`;
    const helpId = `${inputId}-help`;
    return (_jsxs("div", { className: `ipsoft-form-group ${error ? 'ipsoft-form-group-error' : ''} ${className}`, children: [_jsx("label", { htmlFor: inputId, children: label }), _jsx("input", { ref: ref, id: inputId, "aria-invalid": !!error, "aria-describedby": [error ? errorId : '', helpText ? helpId : ''].filter(Boolean).join(' ') || undefined, ...props }), helpText && !error && (_jsx("small", { id: helpId, className: "ipsoft-form-help", children: helpText })), error && (_jsx("small", { id: errorId, className: "ipsoft-form-error", role: "alert", children: error }))] }));
});
Input.displayName = 'Input';
//# sourceMappingURL=Input.js.map